// Copyright (c) 2026 Finerty Data Ltd. All rights reserved.
//
// This file is part of proprietary software owned by Finerty Data Ltd.
// It is confidential and may not be copied, distributed, modified, or used,
// in whole or in part, without the prior written consent of Finerty Data Ltd.
//
// Author: Rafael Pereira Satyro

import type { Icon } from 'iconsax-react';

/**
 * Thin left-pointing chevron (14×14 art). Recolourable via `color` (applied to
 * both fill and stroke); flip it horizontally (e.g. CSS `-scale-x-100`) for a
 * right-pointing chevron. Used for the Risk Assessment prev/next nav buttons.
 */
const ChevronLeftIcon: Icon = ({ size = 24, color, variant: _variant, className, style, ...rest }) => {
  const paint = color || 'currentColor';
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-icon="chevron left"
      className={className}
      style={style}
      {...rest}
    >
      <path
        d="M8.64551 2.27667C8.70071 2.22172 8.79535 2.22176 8.85059 2.27667C8.90585 2.33194 8.90585 2.42746 8.85059 2.48273L5.04785 6.28644C4.65414 6.68034 4.65406 7.31935 5.04785 7.7132L8.85059 11.5169C8.90466 11.571 8.90527 11.6624 8.85352 11.7181C8.81513 11.7523 8.77619 11.7659 8.74805 11.7659C8.71056 11.7659 8.67534 11.7526 8.64551 11.723L4.8418 7.91925C4.33748 7.41487 4.33756 6.58481 4.8418 6.08038L8.64551 2.27667Z"
        fill={paint}
        stroke={paint}
        strokeWidth="0.583333"
      />
    </svg>
  );
};

export { ChevronLeftIcon };
